exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-thumbnail-item{margin:5px 0;position:relative}.search-thumbnail-item__alacarte{position:absolute;right:-16.25px;top:-16.25px}\n", ""]);

// exports
exports.locals = {
	"search-thumbnail-item": "search-thumbnail-item",
	"search-thumbnail-item__alacarte": "search-thumbnail-item__alacarte"
};